"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withEmbeds = exports.insertEmbed = exports.removeEmbedAtPath = exports.updateEmbedAtPath = exports.insertParagraphNearActiveEmbed = exports.getActiveEmbed = exports.getActiveEmbedEntry = exports.normalizeEmbedUrl = exports.isEmbedElement = void 0;
const slate_1 = require("slate");
const voidInsert_1 = require("./voidInsert");
const isEmbedElement = (node) => slate_1.Element.isElement(node) && node.type === 'embed';
exports.isEmbedElement = isEmbedElement;
const normalizeEmbedUrl = (href) => {
    const value = href.trim();
    if (!value)
        return '';
    const nextValue = /^[a-z][a-z0-9+.-]*:/i.test(value) ? value : `https://${value}`;
    try {
        const url = new URL(nextValue);
        if (url.protocol !== 'http:' && url.protocol !== 'https:')
            return '';
        return url.toString();
    }
    catch {
        return '';
    }
};
exports.normalizeEmbedUrl = normalizeEmbedUrl;
const normalizeCaption = (caption) => {
    const value = caption?.trim();
    return value ? value : undefined;
};
const createEmbedElement = (url, caption) => {
    const children = [{ text: '' }];
    const element = {
        type: 'embed',
        url,
        children,
    };
    const nextCaption = normalizeCaption(caption);
    if (nextCaption)
        element.caption = nextCaption;
    return element;
};
const createParagraphElement = () => ({
    type: 'p',
    children: [{ text: '' }],
});
const getActiveEmbedEntry = (editor) => {
    const { selection } = editor;
    if (!selection)
        return null;
    const match = slate_1.Editor.above(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => (0, exports.isEmbedElement)(node),
    });
    return match ?? null;
};
exports.getActiveEmbedEntry = getActiveEmbedEntry;
const getActiveEmbed = (editor) => (0, exports.getActiveEmbedEntry)(editor)?.[0] ?? null;
exports.getActiveEmbed = getActiveEmbed;
const insertParagraphNearActiveEmbed = (editor, position = 'below') => {
    const entry = (0, exports.getActiveEmbedEntry)(editor);
    if (!entry)
        return null;
    const [, path] = entry;
    const targetPath = position === 'above' ? path : slate_1.Path.next(path);
    slate_1.Transforms.insertNodes(editor, createParagraphElement(), { at: targetPath });
    slate_1.Transforms.select(editor, slate_1.Editor.start(editor, targetPath));
    return targetPath;
};
exports.insertParagraphNearActiveEmbed = insertParagraphNearActiveEmbed;
const updateEmbedAtPath = (editor, path, url, caption) => {
    const normalizedUrl = (0, exports.normalizeEmbedUrl)(url);
    if (!normalizedUrl)
        return false;
    if (!slate_1.Node.has(editor, path))
        return false;
    const node = slate_1.Node.get(editor, path);
    if (!(0, exports.isEmbedElement)(node))
        return false;
    slate_1.Transforms.setNodes(editor, { url: normalizedUrl }, { at: path });
    const nextCaption = normalizeCaption(caption);
    if (nextCaption)
        slate_1.Transforms.setNodes(editor, { caption: nextCaption }, { at: path });
    else
        slate_1.Transforms.unsetNodes(editor, 'caption', { at: path });
    return true;
};
exports.updateEmbedAtPath = updateEmbedAtPath;
const removeEmbedAtPath = (editor, path) => {
    if (!slate_1.Node.has(editor, path))
        return false;
    const node = slate_1.Node.get(editor, path);
    if (!(0, exports.isEmbedElement)(node))
        return false;
    slate_1.Transforms.removeNodes(editor, { at: path });
    return true;
};
exports.removeEmbedAtPath = removeEmbedAtPath;
const insertEmbed = (editor, url, caption) => {
    const normalizedUrl = (0, exports.normalizeEmbedUrl)(url);
    if (!normalizedUrl)
        return null;
    return (0, voidInsert_1.insertVoidBlock)(editor, createEmbedElement(normalizedUrl, caption));
};
exports.insertEmbed = insertEmbed;
const withEmbeds = (editor) => {
    const { isVoid, insertBreak, insertSoftBreak, insertText } = editor;
    editor.isVoid = (element) => (element.type === 'embed' ? true : isVoid(element));
    editor.insertBreak = () => {
        if ((0, exports.insertParagraphNearActiveEmbed)(editor, 'below'))
            return;
        insertBreak();
    };
    editor.insertSoftBreak = () => {
        if ((0, exports.insertParagraphNearActiveEmbed)(editor, 'above'))
            return;
        insertSoftBreak();
    };
    editor.insertText = (text) => {
        if (text && (0, exports.insertParagraphNearActiveEmbed)(editor, 'below')) {
            insertText(text);
            return;
        }
        insertText(text);
    };
    return editor;
};
exports.withEmbeds = withEmbeds;
